export default "__VITE_ASSET__DS5ME1A1__"